<template>
  <div>
    <div class="row justify-content-center">
      <div class="col-8">
        <hr>
        <div class="row justify-content-center align-items-center">
          <div class="col-md-4">
            <div class="card">
              <div class="card-body p-4">
                <div class="text-center mb-4">
                  <h3>Iniciar Sesión</h3>
                </div>

                <form @submit.prevent="login">
                  <div class="mb-3">
                    <label for="username" class="form-label">Usuario</label>
                    <input
                      type="text"
                      class="form-control"
                      id="username"
                      v-model="credentials.username"
                      :class="{ 'is-invalid': errors.username }"
                      required
                      autofocus
                    >
                    <div v-if="errors.username" class="invalid-feedback">
                      {{ errors.username }}
                    </div>
                  </div>

                  <div class="mb-3">
                    <label for="password" class="form-label">Contraseña</label>
                    <input
                      type="password"
                      class="form-control"
                      id="password"
                      v-model="credentials.password"
                      :class="{ 'is-invalid': errors.password }"
                      required
                    >
                    <div v-if="errors.password" class="invalid-feedback">
                      {{ errors.password }}
                    </div>
                  </div>

                  <div v-if="generalError" class="alert alert-danger">
                    {{ generalError }}
                  </div>

                  <button
                    type="submit"
                    class="btn btn-primary w-100"
                    :disabled="isLoading"
                  >
                    <span v-if="isLoading" class="spinner-border spinner-border-sm me-2"></span>
                    {{ isLoading ? 'Iniciando sesión...' : 'Iniciar Sesión' }}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'Login',

  data() {
    return {
      credentials: {
        username: process.env.VUE_APP_DEFAULT_USERNAME,
        password: process.env.VUE_APP_DEFAULT_PASSWORD,

      },
      errors: {},
      generalError: '',
      isLoading: false,
      loginUrl: process.env.VUE_APP_API_BASE_URL + 'external_action_login_check'
    }
  },

  methods: {
    async login() {
      this.clearErrors();

      if (!this.validateForm()) {
        return;
      }

      this.isLoading = true;

      try {
        const response = await axios.post(this.loginUrl, {
          _username: this.credentials.username,
          _password: this.credentials.password
        });

        if (response.status === 200 && response.data.token) {
          localStorage.setItem('authToken', response.data.token);

          // Redirigir al componente de búsqueda
          this.$emit('login-success');
        }
      } catch (error) {
        this.handleLoginError(error);
      } finally {
        this.isLoading = false;
      }
    },

    validateForm() {
      let isValid = true;

      if (!this.credentials.username.trim()) {
        this.errors.username = 'El usuario es obligatorio';
        isValid = false;
      }

      if (!this.credentials.password.trim()) {
        this.errors.password = 'La contraseña es obligatoria';
        isValid = false;
      }

      return isValid;
    },

    handleLoginError(error) {
      if (error.response) {
        switch (error.response.status) {
          case 401:
            this.generalError = 'Credenciales incorrectas';
            break;
          case 403:
            this.generalError = 'Acceso denegado';
            break;
          case 429:
            this.generalError = 'Demasiados intentos. Inténtalo más tarde';
            break;
          default:
            this.generalError = 'Error del servidor. Inténtalo más tarde';
            break;
        }
      } else if (error.request) {
        this.generalError = 'Error de conexión. Verifica tu conexión a internet';
      } else {
        this.generalError = 'Error inesperado. Inténtalo más tarde';
      }
    },

    clearErrors() {
      this.errors = {};
      this.generalError = '';
    }
  }
}
</script>
